import React from 'react';

import { Button } from './style';

const ViewButton = ({
  text = '',
  size = '',
  classNames,
  onClick = null,
  variant = '',
  children,
  ...rest
}) => (
  (
    <Button
      type="button"
      onClick={onClick}
      className={classNames}
      size={size}
      variant={variant}
      {...rest}
    >
      {children || text}
    </Button>
  )
);

export { ViewButton };
